<template>
  <v-card-text class="pa-0 d-flex flex-column" style="height: 90%;min-height: 600px;">
    <Questions
      ref="sq48q0"
      @goToNextQuestion="goToNextQuestion"
      :isCurrency="false"
      :dataSeted="dataSeted"
      :question="questionData.questions[0]"
      :screens_question="questionData.question"
      :sq_aclaration="questionData.aclaration"
      @sendAnswer="answerTheIdeaToTakeTheCar"
      @changeDataSeted="changeDataSeted">
    </Questions>
    <Questions
      ref="sq48q1"
      @goToNextQuestion="goToNextQuestion"
      :dataSeted="dataSeted"
      :btnWidth="210"
      :question="questionData.questions[1]"
      :screens_question="null"
      :sq_aclaration="null"
      @selectOption="hasCapitalAndUndertands">
    </Questions>
    <Questions
      ref="sq48q2"
      @goToNextQuestion="goToNextQuestion"
      :dataSeted="dataSeted"
      :btnWidth="500"
      :question="questionData.questions[2]"
      :screens_question="null"
      :sq_aclaration="null"
      @selectOption="pendingScoring"
      :class="!showButton ? 'mb-16 pb-16': 'mb-0'">
    </Questions>
    <transition name="ques">
      <NextQuestionButton
        v-if="showButton"
        class="pb-16"
        @goToNextQuestion="goToNextQuestion">
      </NextQuestionButton>
    </transition>
    <v-dialog v-model="pendigAlert" max-width="600px">
      <PendingAlert
        :showDescription="true"
        :pendingMessage="questionData.questions[2].options[0]"
        @exitAlert="exitAlert">
      </PendingAlert>
    </v-dialog>
  </v-card-text>
</template>

<script>
import Questions from '@/components/savings/blocks/Questions'
import NextQuestionButton from '@/components/savings/blocks/NextQuestionButton'
import PendingAlert from '@/components/savings/blocks/PendingAlert'
import { mapGetters } from 'vuex'
import { answerData } from '@/mixins/answerData'
import Helper from '../../../../helpers/Helper'

export default {
  name: 'SQuesFortyEight',
  components: {
    Questions,
    NextQuestionButton,
    PendingAlert
  },
  props: {
    questionData: Object
  },
  data () {
    return {
      showButton: false,
      pendigAlert: false,
      dataSeted: false,
      question0: '',
      decisionQuestionFirstValue: '',
      questionPending: '',
      historyFirstValue: [],
      historyScrap: [],
      deleteData: [],
      sq_data: [
        {
          question_id: this.questionData.questions[0].id,
          ponderation: '',
          updated_at: ''
        },
        {
          question_id: this.questionData.questions[1].id,
          ponderation: '',
          updated_at: ''
        },
        {
          question_id: this.questionData.questions[2].id,
          ponderation: '',
          updated_at: ''
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getOperationNumber',
      'scoringData',
      'isBrowsingInScoringHistory',
      'continueScoring',
      'getIndexOfCurrentSQ',
      'getHistory',
      'SQNameByNumber',
      'sq_number'
    ])
  },
  methods: {
    setData (sqdata) {
      if (this.scoringData[sqdata] !== null) {
        this.showButton = true
        this.dataSeted = true
        this.$emit('handleProgress', 40)
        this.$refs.sq48q0.setAnswer(this.scoringData[sqdata][0].ponderation)
        this.$refs.sq48q1.setAnswer(this.scoringData[sqdata][1].ponderation)
        this.$refs.sq48q2.setAnswer(this.scoringData[sqdata][2].ponderation)
        for (let i = 0; i < 3; i++) {
          this.sq_data[i].ponderation = this.scoringData[sqdata][i].ponderation
          this.sq_data[i].updated_at = this.scoringData[sqdata][i].updated_at
          if (this.continueScoring) {
            if (this.scoringData[sqdata][0].id !== undefined) {
              this.sq_data[i].id = this.scoringData[sqdata][i].id
            }
          }
        }
        if (this.isBrowsingInScoringHistory) {
          this.question0 = this.scoringData[sqdata][0].ponderation
          this.decisionQuestionFirstValue = this.scoringData[sqdata][1].ponderation
          this.questionPending = this.scoringData[sqdata][2].ponderation
          this.historyFirstValue = this.getHistory
        }
      }
    },
    answerTheIdeaToTakeTheCar (value) {
      this.sq_data[0].ponderation = value
      this.sq_data[0].updated_at = Helper.setDateAndTime()
    },
    hasCapitalAndUndertands (value) {
      this.showButton = true
      this.sq_data[1].ponderation = value
      this.sq_data[1].updated_at = Helper.setDateAndTime()
      this.sq_data[2].ponderation = ''
      this.sq_data[2].updated_at = Helper.setDateAndTime()
      this.$refs.sq48q2.setSelectedButton(null)
      if (this.continueScoring) {
        if (this.isBrowsingInScoringHistory && this.sq_data[2].id !== undefined) {
          this.$emit('editQuestion', this.sq_data[2])
        }
      }
    },
    pendingScoring (value) {
      this.sq_data[2].ponderation = value
      this.sq_data[2].updated_at = Helper.setDateAndTime()
      this.sq_data[1].ponderation = ''
      this.sq_data[1].updated_at = Helper.setDateAndTime()
      this.$refs.sq48q1.setSelectedButton(null)
      if (this.continueScoring) {
        if (this.isBrowsingInScoringHistory && this.sq_data[1].id !== undefined) {
          this.$emit('editQuestion', this.sq_data[1])
        }
      }
      this.showButton = false
      this.deleteHistoryIfIsNecessary()
      this.$store.dispatch('handleScoringData', this.sq_data)
      this.pendigAlert = true
    },
    exitAlert () {
      this.pendigAlert = false
    },
    goToNextQuestion () {
      this.handleIfEditQuesInSQWithoutCurrentQues(0, this.question0)
      this.handleIfEditQuesInSQWithoutCurrentQues(2, this.questionPending)
      this.deleteHistoryIfIsNecessary()
      this.$store.dispatch('handleScoringData', this.sq_data)
      if (this.sq_data[1].ponderation === this.questionData.questions[1].options[0]) {
        this.$emit('handleProgress', 45)
        if (this.isBrowsingInScoringHistory) {
          this.$emit('reduceDecreasing', 1)
          this.$store.dispatch('handleOnlyCurrentSQ', 6)
        } else {
          this.$store.dispatch('handleCurrentSQ', 6)
        }
      } else {
        this.$emit('handleProgress', 40)
        if (this.isBrowsingInScoringHistory) {
          this.$emit('reduceDecreasing', 1)
          this.$store.dispatch('handleOnlyCurrentSQ', 49)
        } else {
          this.$store.dispatch('handleCurrentSQ', 49)
        }
      }
      this.$emit('checkIfHistoryModeContinues')
    },
    deleteHistoryIfIsNecessary () {
      if (this.isBrowsingInScoringHistory) {
        if (this.decisionQuestionFirstValue !== this.sq_data[1].ponderation) {
          this.$emit('reduceDecreasing', 1)
          this.handleIfEditDecisionQues(1, this.decisionQuestionFirstValue)
          this.historyScrap = this.historyFirstValue.splice(this.getIndexOfCurrentSQ + 1)
          this.historyScrap.forEach(e => {
            if (e !== 2 && e !== 32 && e !== 41) {
              if (this.scoringData[this.SQNameByNumber[e]] !== null) {
                if (this.scoringData[this.SQNameByNumber[e]][0].id === undefined) {
                  this.$store.dispatch('handleResetScoringData', e)
                } else {
                  this.scoringData[this.SQNameByNumber[e]].forEach(q => {
                    this.deleteData.push(q.id)
                  })
                  this.$store.dispatch('handleResetScoringData', e)
                }
              }
            }
          })
          this.$emit('deleteQuestion', this.deleteData)
          this.$store.dispatch('handleHistoryData', this.historyFirstValue)
          this.$store.dispatch('handleIfIsBrowsingInScoringHistory', false)
          this.$store.dispatch('handleHistoryIndexOfCurrentSQ', null)
        }
      }
    }
  },
  mixins: [answerData],
  mounted () {
    this.setData('sq_fortyEightData')
  }
}
</script>

<style lang="scss" scoped>
.ques-enter-active {
  transition: opacity .5s;
}
.ques-enter {
  opacity: 0;
}
</style>
